import { ErrorIcon } from '@commenda/icons';
import { Icons } from '@commenda/kakashi';
import { classNames } from '@commenda/utils';

const ChartValidationError = ({
  directorVsSharePercentage,
  value,
}: {
  directorVsSharePercentage?: Record<
    number,
    { name: string; sharePercentage: number }
  >;
  // TODO: Add KS Version for now
  value?: number;
}) => {
  const totalPercentage =
    value ||
    Object.values(directorVsSharePercentage || {}).reduce(
      (each, acc) => each + (acc.sharePercentage || 0),
      0
    );

  return (
    <div className="flex gap-1 items-center">
      {totalPercentage !== 100 ? (
        <ErrorIcon className="h-4 w-4 text-error-100" />
      ) : (
        <Icons.CheckCircle className="h-4 w-4 text-success-100" />
      )}
      <div className="body-12-medium text-neutral-4">
        <span
          className={classNames(
            totalPercentage !== 100 ? 'text-error-100' : 'text-good-to-go-100'
          )}
        >
          {totalPercentage}%
        </span>
        <span>&nbsp;of&nbsp;</span>
        <span>100%</span>
      </div>
    </div>
  );
};

export default ChartValidationError;
